import { isSameDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { convertMomentFormat, formatDate } from 'lib/helpers/dateUtils';
import { ia } from 'lib/helpers/utility';

export const formattedValue = ({ value, format, isRange, timezone = null }) => {
  const fmt = convertMomentFormat(format);

  if (!isRange) {
    return value ? formatDate(value, timezone, fmt) : '';
  }

  if (!ia(value) || !value[0] || !value[1]) return '';

  const d0 = timezone ? toZonedTime(new Date(value[0]), timezone) : new Date(value[0]);
  const d1 = timezone ? toZonedTime(new Date(value[1]), timezone) : new Date(value[1]);

  if (isSameDay(d0, d1)) {
    return `${formatDate(value[0], timezone, 'MM/dd/yyyy, h:mm a')} - ${formatDate(value[1], timezone, 'h:mm a')}`;
  }

  return [formatDate(value[0], timezone, fmt), formatDate(value[1], timezone, fmt)].join(' - ');
};
